import styled from 'styled-components';

export const CatchmentFilterStyle = styled.div`
  .submitButton {
    margin-top: 3rem;
    text-align: center;
  }
`;
